import { axiosInstance } from ".."

const rsFormView = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`public/storage/projects/${id}.pdf?signed=1`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default rsFormView;